import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class ScrollInterview {
    constructor() {
        this.init();
    }

    init() {
        this.setScrollTrigger();
    }

    setScrollTrigger() {
        const scins = [...document.querySelectorAll(".js-scrollin")];
        const startPos = window.innerWidth <= 865 ? "top 80%" : "top 80%";

        scins.forEach((ref) => {
            ScrollTrigger.create({
                trigger: ref,
                scroller: ".interview_modal",
                start: startPos,
                //markers: true,
                onEnter: () => {
                    ref.classList.add("-scrollin");
                },
            });
        });
    }
}
